<template lang="pug">
	div.default-modal
		.modal-header
			.modal-title Generated Reports
			a.close(href="javascript:void(0);", @click="$emit('close')")
				i.la.la-times
		.modal-body
			loading(:active.sync="busy", :is-full-page="true")
			.modal-body-inner
				paginate(:paginator="paginate", @update-page-size="loadData")
				ov-table-scroll
					table.table.table-bordered.table-offer-list
						thead
							tr
								th ID
								th Created At
								th Status
								th Download
						tbody
							tr(v-if="records.length === 0")
								td(colspan="4") No matching records were found
							tr(v-for="r in records", v-bind:key="r.id")
								td {{ r.id }}
								td {{ r.created_at }}
								td {{ r.status === 'new' ? generatingText : r.status }}
								td
									a(v-if="r.status === 'complete' && r.path", href="#", @click="download(r)") Download
</template>
<script>
import { downloadFile } from '../../lib/files';

const REFRESH_INTERVAL = 5 * 1000;
const DOT_INTERVAL = 500;

export default {
  name: 'GeneratedReportsModal',
  props: [],
  data() {
    return {
      busy: false,
      refreshInterval: null,
      dotInterval: null,
      generatingDotCount: 0,
      records: [],
      /** To prevent showing loading spinner on automatic refresh loads */
      initialLoad: true,
      paginate: {
        numPages: 0,
        total: 0,
        page: 1,
        limit: 50,
        onPageChange: () => {
          this.loadData();
        },
      },
    };
  },
  computed: {
    generatingText() {
      return `Generating${'.'.repeat(this.generatingDotCount)}`;
    },
  },
  methods: {
    async loadData() {
      this.busy = this.initialLoad;
      let params = {
        page: this.paginate.page,
        page_size: this.paginate.limit,
      };
      try {
        let resp = await this.$ovReq.get('reports/getGeneratedList', { params });
        this.records = resp.records;
        this.paginate.total = resp.total;
        this.paginate.numPages = Math.max(Math.ceil(this.paginate.total / this.paginate.limit), 1);
        this.initialLoad = false;
      } catch (e) {
        console.error(e);
      }
      this.busy = false;
    },

    async download(report) {
      const filename = `background_report_${report.id}.csv`;
      await downloadFile(report.path, filename);
    },

    startAutoRefresh() {
      if (this.refreshInterval) {
        return;
      }
      this.refreshInterval = setInterval(() => {
        this.loadData();
      }, REFRESH_INTERVAL);
    },

    stopAutoRefresh() {
      if (!this.refreshInterval) {
        return;
      }
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    },

    startGeneratingAnimation() {
      if (this.dotInterval) {
        return;
      }
      this.dotInterval = setInterval(() => {
        this.generatingDotCount = (this.generatingDotCount + 1) % 4;
      }, DOT_INTERVAL);
    },

    stopGeneratingAnimation() {
      if (!this.dotInterval) {
        return;
      }
      clearInterval(this.dotInterval);
      this.dotInterval = null;
    },
  },
  mounted() {
    this.loadData();
    this.startAutoRefresh();
    this.startGeneratingAnimation();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
    this.stopGeneratingAnimation();
  },
};
</script>
